<template>
  <InsideContent
    :title="$t('ADVERTISEMENT.CAMPAIGN_FINANCE.TITLE')"
    :description="$t('ADVERTISEMENT.CAMPAIGN_FINANCE.DESCRIPTION')"
  >
    <EditCampaignBudgetAction
      :budget-allocation-limit="budgetAllocationLimit"
      :credit="credit"
      @changed="getCampaignBudget"
    />
    <CardApiError v-if="apiError" @retry="getCampaignBudget" />
    <BudgetInfo
      v-else
      :loading="isLoading"
      :title="$t('ADVERTISEMENT.CAMPAIGN_FINANCE.REMAINING_BUDGET')"
      :no-credit-text="$t('ADVERTISEMENT.CAMPAIGN_FINANCE.OUT_OF_BUDGET')"
      :credit="credit"
    />
  </InsideContent>
</template>

<script>
import EditCampaignBudgetAction from './EditCampaignBudgetAction';
import BudgetInfo from '@@/common/BudgetInfo';

import InsideContent from '@@/common/layout/InsideContent';
import CardApiError from '@@/common/CardApiError';

import { AdCampaignFinance } from '@/api/api';
import campaignId from '@/mixins/advertisement/campaignId';

export default {
  name: 'CampaignBudget',
  components: {
    EditCampaignBudgetAction,
    BudgetInfo,
    InsideContent,
    CardApiError,
  },
  mixins: [campaignId],
  data() {
    return {
      credit: 0,
      budgetAllocationLimit: 0,

      isLoading: false,
      apiError: false,
    };
  },
  mounted() {
    this.getCampaignBudget();
  },
  methods: {
    getCampaignBudget() {
      this.isLoading = true;
      this.apiError = false;
      return AdCampaignFinance.getCampaignBudget({
        itemId: this.campaignId,
      })
        .then(
          ({
            body: {
              budget,
              gift_budget: giftBudget,
              budget_allocation_limit: budgetAllocationLimit,
            },
          }) => {
            this.credit = budget + giftBudget;
            this.budgetAllocationLimit = budgetAllocationLimit;
          },
        )
        .catch(({ body: { message } }) => {
          if (message) {
            this.$message.error(message);
          }
          this.apiError = true;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>
